export default "__VITE_ASSET__B_Oi3ckQ__"